module.exports = __webpack_public_path__ + "img/menu-report.0fc5f6a1.png";